import Infopib from "../../components/infopib"

function signOut() {
    localStorage.removeItem('user')
    localStorage.removeItem('token')
    localStorage.removeItem('organization')
    localStorage.removeItem('announcements')
    window.location.href = `${window.location.origin}/signin`
}

export default function Error403() {


    return (
        <>
            <Infopib />
            <main className="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
                <div className="text-center">
                    <p className="text-base font-semibold text-indigo-600">403</p>
                    <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">User Access Forbidden</h1>
                    <p className="mt-6 text-base leading-7 text-gray-600">Sorry, you do not have access to the page you are requesting.</p>
                    <div className="mt-10 flex items-center justify-center gap-x-6">
                        <a
                            href="/dashboard"
                            className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                        >
                            Back to Dashboard
                        </a>
                        <button
                            onClick={()=>{signOut()}}
                            className=" rounded-md bg-red-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
                        >
                            Sign out
                        </button>
                    </div>
                </div>
            </main>
        </>
    )
}
